var _path, _path2, _circle, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42.5 42.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M31.1 37.5H18.9c-2.5 0-4.6-2.1-4.6-4.6V15.7c0-2.5 2.1-4.6 4.6-4.6h12.4c2.5 0 4.6 2.1 4.6 4.6v17.4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_sub",
    d: "M20 27.6h10.5M24.8 21.7h5.7"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_dot",
    cx: 20,
    cy: 21.7,
    r: 1.4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_sub",
    d: "M9.6 28.7c-1.7-.5-2.9-2.1-2.9-4V9.2C6.6 6.9 8.5 5 10.8 5H22c1.1 0 2.1.4 2.8 1.1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.c6d79c415c399ae2ad52db23ae5c9f56.svg";
export { ForwardRef as ReactComponent };